import { Language } from '~common/i18n';
import {
  EventNotificationSubscriptions,
  EventRestrictions,
  EventTimelineGroup,
  EventTranslationData,
  EventTranslations,
} from '~admin/model/event-translation-data';
import { EventRestrictionTranslationResponse } from '~client/model/admin/event-restriction-translation-response';
import { EventTimelineGroupTranslationResponse } from '~client/model/admin/event-timeline-group-translation-response';
import { EventTranslationResponse } from '~client/model/admin/event-translation-response';
import { EventTranslationResponseItem } from '~client/model/admin/event-translation-response-item';
import { ExternalNotificationSubscriptionTranslationResponse } from '~client/model/admin/external-notification-subscription-translation-response';

const mapEventRestrictions = (
  response: EventRestrictionTranslationResponse[],
): EventRestrictions[] =>
  response.map(({ restrictionId, eventRestrictionTranslationResponseItems }) => ({
    restrictionId,
    restrictionTranslations: eventRestrictionTranslationResponseItems?.map(
      ({ description, secondaryDescription, url, locale }) => ({
        description,
        url,
        secondaryDescription,
        language: locale as Language,
      }),
    ),
  }));

const mapEventTimelineGroups = (
  response: EventTimelineGroupTranslationResponse[],
): EventTimelineGroup[] =>
  response.map(
    ({ groupId, eventTimelineTranslationGroupResponseItems, timelineTranslationResponses }) => ({
      groupId,
      groupTranslations: eventTimelineTranslationGroupResponseItems?.map(({ title, locale }) => ({
        title,
        language: locale as Language,
      })),
      groupItems: timelineTranslationResponses?.map(
        ({ rank, eventTimelineTranslationResponseItems }) => ({
          rank,
          itemTranslations: eventTimelineTranslationResponseItems?.map(
            ({ title, description, locale }) => ({
              title,
              description,
              language: locale as Language,
            }),
          ),
        }),
      ),
    }),
  );

const mapEventTranslations = (response: EventTranslationResponseItem[]): EventTranslations[] =>
  response.map(({ eventName, optionalLongDescription, locale }) => ({
    eventName,
    eventDescription: optionalLongDescription,
    language: locale as Language,
  }));

const mapEventNotificationSubscriptions = (
  response: ExternalNotificationSubscriptionTranslationResponse[],
): EventNotificationSubscriptions[] =>
  response.map(
    ({
      externalNotificationSubscriptionId,
      externalNotificationSubscriptionTranslationResponseItems,
    }) => ({
      subscriptionId: externalNotificationSubscriptionId,
      subscriptionTranslations: externalNotificationSubscriptionTranslationResponseItems.map(
        ({ displayString, locale }) => ({
          displayString,
          language: locale as Language,
        }),
      ),
    }),
  );

export const mapEventTranslationData = (
  response: EventTranslationResponse,
): EventTranslationData => {
  const {
    eventId,
    eventNotificationSubscriptionTranslationResponse,
    eventRestrictionTranslationResponse,
    eventTimelineGroupTranslationResponseItems,
    eventTranslationResponseItems,
  } = response;

  return {
    eventId: Number(eventId),
    eventRestrictions: mapEventRestrictions(eventRestrictionTranslationResponse),
    eventTimelineGroups: mapEventTimelineGroups(eventTimelineGroupTranslationResponseItems),
    eventTranslations: mapEventTranslations(eventTranslationResponseItems),
    eventNotificationSubscriptions: mapEventNotificationSubscriptions(
      eventNotificationSubscriptionTranslationResponse,
    ),
  };
};



// WEBPACK FOOTER //
// ./model/event-translation-data.mapper.ts